import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StagesStatusListComponent } from './stages-status-list/stages-status-list.component';
import { StagesStatusFormComponent } from './stages-status-form/stages-status-form.component';
import { RenderersModule } from 'src/app/shared/renderers/renderers.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    StagesStatusListComponent,
    StagesStatusFormComponent
  ],
  imports: [
    CommonModule,
    RenderersModule,
    SharedModule,
    ReactiveFormsModule,
  ]
})
export class StagesStatusModule { }
